export default function getLodgeDetailsFactory(ajax, getSession) {
  return async function getLodgeDetail(id) {
    return ajax({ resource: `lodgings/lodges/${id}`, method: 'get' });
  };
}



// WEBPACK FOOTER //
// ./src/services/getLodgeDetail.js